// client/src/planConfig.js
// Single source of truth for plan tiers, limits, and add-ons.
// ⚠️  Keep tendermaker/planConfig.js in sync (CommonJS copy for backend).

export const PLAN_CONFIG = {
  demo: {
    id: 'demo',
    label: 'Demo',
    durationDays: 3,
    priceInr: 0,
    priceInPaise: 0,
    limits: { searches: 50, results: 50, tmBids: 1, reportRows: 100 },
  },
  basic: {
    id: 'basic',
    label: 'Basic',
    durationDays: 365,
    priceInr: 9999,
    priceInPaise: 999900,
    limits: { searches: 500, results: 500, tmBids: 5, reportRows: 2000 },
  },
  pro: {
    id: 'pro',
    label: 'Pro',
    durationDays: 365,
    priceInr: 14999,
    priceInPaise: 1499900,
    limits: { searches: 1000, results: 1000, tmBids: 15, reportRows: 5000 },
  },
  research: {
    id: 'research',
    label: 'Research',
    durationDays: 365,
    priceInr: 29999,
    priceInPaise: 2999900,
    limits: { searches: 2000, results: 2000, tmBids: 30, reportRows: 20000 },
  },
};

export const ADDON_CONFIG = {
  searches100: {
    id: 'searches100',
    label: '+100 Tender Discovery Credits',
    quotaField: 'searches',
    amount: 100,
    priceInr: 499,
    priceInPaise: 49900,
  },
  results100: {
    id: 'results100',
    label: '+100 Results Analysis Credits',
    quotaField: 'results',
    amount: 100,
    priceInr: 999,
    priceInPaise: 99900,
  },
  tmBids5: {
    id: 'tmBids5',
    label: '+5 Bid Analyses',
    quotaField: 'tmBids',
    amount: 5,
    priceInr: 999,
    priceInPaise: 99900,
  },
  reportRows5000: {
    id: 'reportRows5000',
    label: '+5,000 Report Rows',
    quotaField: 'reportRows',
    amount: 5000,
    priceInr: 999,
    priceInPaise: 99900,
  },
};

export const QUOTA_CYCLE_DAYS = 30;

export function getLimitsForPlan(planId) {
  const key = (planId || '').toLowerCase();
  const cfg = PLAN_CONFIG[key];
  if (cfg) return { ...cfg.limits };
  // Unknown plan — return demo limits as safe fallback
  return { ...PLAN_CONFIG.demo.limits };
}

// ALL legacy/old plan names → basic. Includes old 'trial' users.
// 'demo' is the new free trial plan and is NOT legacy.
// Migration only applies if endDate > now (active). Expired users stay as-is.
export const LEGACY_PLAN_MAP = {
  trial: 'basic',
  weekly: 'basic',
  monthly: 'basic',
  annual: 'basic',
  combo: 'basic',
  combotr: 'basic',
};
